var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69157 3.94675L7.3915 11.1485C7.38563 11.2894 7.26032 11.4092 7.11849 11.4092H1.88213C1.74036 11.4092 1.61497 11.289 1.60912 11.1485L1.30904 3.94675C1.29964 3.72102 1.10902 3.54564 0.883278 3.55505C0.657539 3.56445 0.482166 3.75508 0.491572 3.98082L0.791645 11.1826C0.815763 11.7614 1.30181 12.2274 1.88213 12.2274H7.11849C7.69846 12.2274 8.18482 11.7621 8.20897 11.1826L8.50904 3.98082C8.51845 3.75508 8.34308 3.56445 8.11734 3.55505C7.8916 3.54564 7.70098 3.72102 7.69157 3.94675Z",
    fill: "#F40101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17285 4.61829V10.1819C4.17285 10.3627 4.31938 10.5092 4.50012 10.5092C4.68087 10.5092 4.8274 10.3627 4.8274 10.1819V4.61829C4.8274 4.43754 4.68087 4.29102 4.50012 4.29102C4.31938 4.29102 4.17285 4.43754 4.17285 4.61829Z",
    fill: "#F40101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37319 4.62791L2.53683 10.1915C2.54214 10.3722 2.69291 10.5144 2.87358 10.5091C3.05425 10.5037 3.1964 10.353 3.19109 10.1723L3.02745 4.60867C3.02214 4.428 2.87137 4.28585 2.6907 4.29116C2.51003 4.29647 2.36788 4.44724 2.37319 4.62791Z",
    fill: "#F40101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97286 4.60867L5.80923 10.1723C5.80391 10.353 5.94607 10.5037 6.12674 10.5091C6.30741 10.5144 6.45817 10.3722 6.46349 10.1915L6.62712 4.62791C6.63244 4.44724 6.49029 4.29647 6.30962 4.29116C6.12895 4.28585 5.97818 4.428 5.97286 4.60867Z",
    fill: "#F40101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.409091 2.98127H8.59091C8.81684 2.98127 9 2.79811 9 2.57218C9 2.34624 8.81684 2.16309 8.59091 2.16309H0.409091C0.183156 2.16309 0 2.34624 0 2.57218C0 2.79811 0.183156 2.98127 0.409091 2.98127Z",
    fill: "#F40101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25692 2.43939L3.42726 1.84318C3.46375 1.71548 3.62928 1.59064 3.76217 1.59064H5.23768C5.37066 1.59064 5.53608 1.71538 5.5726 1.84318L5.74294 2.43939L6.52964 2.21462L6.3593 1.61841C6.22241 1.13931 5.73591 0.772461 5.23768 0.772461H3.76217C3.26401 0.772461 2.77741 1.13944 2.64056 1.61841L2.47021 2.21462L3.25692 2.43939Z",
    fill: "#F40101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDeleteIcon);
export default __webpack_public_path__ + "static/media/newDeleteIcon.4d1cd720c71f85772417a276eb06822b.svg";
export { ForwardRef as ReactComponent };